import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { PublishedAuctionListService } from '../../../Shared/Services/published-auction-list.service';
import { CompileShallowModuleMetadata } from '@angular/compiler';

declare var $: any;

@Component({
  selector: 'app-published-auction-list',
  templateUrl: './published-auction-list.component.html',
  styleUrls: ['./published-auction-list.component.css']
})
export class PublishedAuctionListComponent implements OnInit {
  // FrmPublishedAuctionList: FormGroup;
  AuctionLiveListBind: any = [];
  DownloadAuctionViewList: any = [];
  AuctionId: number;

  //************* Live Auction List Column And DataSource ****************/
  displayedColumns: string[] = ['SrNo', 'AuctionNo', 'AuctionTitle', 'StartDate', 'EndDate', 'Action'];
  dataSourceLive = new MatTableDataSource(this.AuctionLiveListBind);

  displayedColumnsDownloadAuctionLive: string[] = ['SrNo', 'DocumentName', 'Description', 'Download'];////'DocumentType',
  dataSourceDownloadAuctionLiveView = new MatTableDataSource(this.DownloadAuctionViewList);


  //************ For Use Multiple Pagination On Page */
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();


  constructor(private MsgService: ToastrService, private servc: PublishedAuctionListService) { }

  ngOnInit() {
    this.BindPublishedAuctionList();
  }

  applyFilter(filterValue: string) {
    this.dataSourceLive.filter = filterValue.trim().toLowerCase();
  }
  BindPublishedAuctionList() {
    try {
      let ResponseDecrpt = sessionStorage.getItem('loginSession');
      let loginlist = JSON.parse(window.atob(ResponseDecrpt));

      let Ind = 1;
      let OrgCode = loginlist[0]['OrgCode'];
      let CityCode = loginlist[0]['CityCode'];
      let ZoneCode = loginlist[0]['ZoneCode'];

      this.servc.GetAuctionPublishedGrid(Ind, OrgCode, CityCode, ZoneCode).subscribe(resp => {
        if (resp) {
          if (resp.SuccessCD == 1 && resp.RespData != null) {

            this.AuctionLiveListBind = resp.RespData.Table;
            // Change 04-07-2020
            //this.AuctionLiveDocsListBind = resp.RespData.Table1;          

            this.dataSourceLive = new MatTableDataSource<any>(this.AuctionLiveListBind);
            this.dataSourceLive.paginator = this.paginator.toArray()[0];
            this.dataSourceLive.sort = this.sort.toArray()[0];

          } else {
            this.MsgService.warning(resp.MsgDesc);
          }
        } else {
          this.MsgService.error('Server Side Error...');
        }
      }, err => {
        this.MsgService.error(err);
      });
    }
    catch (error) {
      this.MsgService.error(error);
    }
  }
  OnAuctionPublish() {

    let ok = confirm("Are You Sure Want To Publish Auction...??")
    if (ok) {
      let ResponseDecrpt = sessionStorage.getItem('loginSession');
      let loginlist = JSON.parse(window.atob(ResponseDecrpt));

      let Ind = 3;
      let OrgCode = loginlist[0]['OrgCode'];
      let CityCode = loginlist[0]['CityCode'];
      let PublishByUserId = loginlist[0]['UserId'];
      let AuctionId = this.AuctionId;
      this.servc.UpdatePublishedAuctionList(Ind, OrgCode, CityCode, PublishByUserId, AuctionId).subscribe(resp => {

        if (resp) {
          if (resp.SuccessCD == 1 && resp.RespData != null) {

            this.MsgService.success("Auction Published Successfully...!!");
            this.BindPublishedAuctionList();
            $('#myModal').modal('hide');

          }
        }
      })


    } else {

    }

  }

  AuctionShowList: any = [];
  viewdata(AuctionId: number, AuctionNo: string, ActiveInd: number) {
    this.AuctionId = AuctionId;
    if (ActiveInd == 0) {
      this.AuctionShowList = null;
      this.AuctionShowList = this.AuctionLiveListBind.filter(m => m.AuctionNo == AuctionNo);
      this.ViewAuctionPartcipateData(AuctionId);

    }
  }

  ViewAuctionPartcipateData(AuctionID: number) {//,row?.AuctionNo
    try {

      let ResponseDecrpt = sessionStorage.getItem('loginSession');
      let loginlist = JSON.parse(window.atob(ResponseDecrpt));
      let Ind = 2;
      let OrgCode = loginlist[0]['OrgCode'];
      let CityCode = loginlist[0]['CityCode'];
      // let FirmCd = loginlist[0]['FirmCd'];
      this.servc.GetAuctionParticipateViewData(Ind, OrgCode, CityCode, AuctionID).subscribe(resp => {
        if (resp) {
          if (resp.SuccessCD == 1 && resp.RespData != null) {

            this.DownloadAuctionViewList = resp.RespData.Table;
           
            /******* Change 26-04-2020 for view live list docs ***************/
            this.dataSourceDownloadAuctionLiveView = new MatTableDataSource<any>(this.DownloadAuctionViewList);
            this.dataSourceDownloadAuctionLiveView.paginator = this.paginator.toArray()[4];
            this.dataSourceDownloadAuctionLiveView.sort = this.sort.toArray()[4];

          } else {
            this.MsgService.warning(resp.MsgDesc);
          }
        } else {
          this.MsgService.error('Server Side Error...');
        }
      }, err => {
        this.MsgService.error(err);
      });
    }
    catch (error) {
      this.MsgService.error(error);
    }

  }
  /***************Change 26-04-2020 **********/
  DownloadFilterAuctionPending: any = []
  OnDownloadAuctionPending(AutoId: any, AuctionId: any, SrNo: Number) {
    this.DownloadFilterAuctionPending = [];
    this.DownloadFilterAuctionPending = this.DownloadAuctionViewList.filter(m => m.AutoId == AutoId && m.AuctionId == AuctionId && m.SrNo == SrNo);

    let DownLLink = this.DownloadFilterAuctionPending[0]['VirtualPath']
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = DownLLink;
    link.setAttribute('visibility', 'hidden');//JMCEauctionAPI\Documents\AuctionPDF
    link.click();

  }

}
